module.exports = __webpack_public_path__ + "static/media/verifyStep.82a48a27.png";